import React, {Component} from 'react';

class TAll extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'all',
		}
	}

	render() {
		const all_research_achievements = this.props.stats.all_research_achievements;

		return (
			<div className="tab-data active">
				<table className="table table-lightgray table-border">
					<colgroup>
						<col width="20%"/>
						<col width="20%"/>
						<col width="20%"/>
						<col width="20%"/>
						<col width="20%"/>
					</colgroup>
					<thead>
					<tr>
						<th scope="col" rowSpan="2">구분</th>
						<th scope="col" colSpan="2">논문수</th>
						<th scope="col" colSpan="2">피인용</th>
					</tr>
					<tr>
						<th scope="col">전체</th>
						<th scope="col">주저자</th>
						<th scope="col">피인용 수</th>
						<th scope="col">피인용 평균</th>
					</tr>
					</thead>
					<tbody>
					{all_research_achievements.SCI &&
					<tr>
						<td>SCI 급</td>
						<td>{all_research_achievements.SCI.publication_count}</td>
						<td>{all_research_achievements.SCI.lead_author_publication_count}</td>
						<td>{all_research_achievements.SCI.cited_count}</td>
						<td>{all_research_achievements.SCI.avg_cited_count}</td>
					</tr>
					}
					{all_research_achievements.Scopus &&
					<tr>
						<td>Scopus</td>
						<td>{all_research_achievements.Scopus.publication_count}</td>
						<td>{all_research_achievements.Scopus.lead_author_publication_count}</td>
						<td>{all_research_achievements.Scopus.cited_count}</td>
						<td>{all_research_achievements.Scopus.avg_cited_count}</td>
					</tr>
					}
					{all_research_achievements.KCI &&
					<tr>
						<td>KCI</td>
						<td>{all_research_achievements.KCI.publication_count}</td>
						<td>{all_research_achievements.KCI.lead_author_publication_count}</td>
						<td>{all_research_achievements.KCI.cited_count}</td>
						<td>{all_research_achievements.KCI.avg_cited_count}</td>
					</tr>
					}
					</tbody>
				</table>
				<table className="table table-lightgray table-border mt-2">
					<colgroup>
						<col width="20%"/>
						<col width="12.5%"/>
						<col width="12.5%"/>
						<col width="12.5%"/>
						<col width="12.5%"/>
					</colgroup>
					<thead>
					<tr>
						<th scope="col" rowSpan="2">구분</th>
						<th scope="col" colSpan="2">상위 1% 논문수</th>
						<th scope="col" colSpan="2">상위 10% 논문수</th>
					</tr>
					<tr>
						<th scope="col">전체</th>
						<th scope="col">주저자</th>
						<th scope="col">피인용 수</th>
						<th scope="col">피인용 평균</th>
					</tr>
					</thead>
					<tbody>
					{all_research_achievements.SCI &&
					<tr>
						<td>SCI 급</td>
						<td>{all_research_achievements.SCI.top1_publication_count}</td>
						<td>{all_research_achievements.SCI.top1_lead_author_publication_count}</td>
						<td>{all_research_achievements.SCI.top1_publication_count}</td>
						<td>{all_research_achievements.SCI.top10_lead_author_publication_count}</td>
					</tr>
					}
					{all_research_achievements.Scopus &&
					<tr>
						<td>Scopus</td>
						<td>{all_research_achievements.Scopus.top1_publication_count}</td>
						<td>{all_research_achievements.Scopus.top1_lead_author_publication_count}</td>
						<td>{all_research_achievements.Scopus.cited_count}</td>
						<td>{all_research_achievements.Scopus.avg_cited_count}</td>
					</tr>
					}
					{all_research_achievements.KCI &&
					<tr>
						<td>KCI</td>
						<td>{all_research_achievements.KCI.top1_publication_count}</td>
						<td>{all_research_achievements.KCI.top1_lead_author_publication_count}</td>
						<td>{all_research_achievements.KCI.top1_publication_count}</td>
						<td>{all_research_achievements.KCI.top10_lead_author_publication_count}</td>
					</tr>
					}
					</tbody>
				</table>
			</div>
		);
	}
};

export default TAll;
